import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import ColorBox from '../ColorBox';
import SimpleSTLViewer from '../Canvas/SimpleStlViews';
import validateError from '../../ValidateError';
import vAdminformat from '../../adminFormat';
import STLViewerQuot from '../Canvas/STLViewerQuot';
import getFileExtension from '../getFileExtension';

const server_backend = config.API_URL;

function UpdateQuotation({ username, onQuotationID, onClose, getQuotations }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    //Test


    const [showDropdown, setShowDropdown] = useState(false);
    const [STLfileBussiness, setSTLFileBussiness] = useState(null);
    const [customerFiles, setCustomerFile] = useState([]);
    const [fileURL, setFileURL] = useState("");
    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterialColor, setSelectedMaterialColor] = useState('#FFFFFF');
    const [selectedMaterial, setSelectedMaterial] = useState(null);

    const [fileUploadList, setFileUploadlist] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [currentDencity, setCurrentDencity] = useState(0);
    const [materialPrice, setMaterialPrice] = useState([]);
    const [currentPrice, setCurrentPrice] = useState(0);
    const [ConfUpload, setConfUpload] = useState(false);
    const [getBussinessFiles, setGetBussinessFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0); //Now we just need general progress


    const [isUpdateJob, setIsUpdateJob] = useState(0);
    const [statusQuot, setStatusQuot] = useState([]);
    const [isPrivate, setIsPrivate] = useState(0);
    const [isInitialized, setIsInitialized] = useState(false);
    const [currentCustomer, setCurrentCustomer] = useState(0);
    const [nanito, setNanito] = useState(false);
    const [AliasFileName, setAliasFileName] = useState(null);
    const [searchTerm, setSearchTerm] = useState(''); //Status to store the search term


    const [filteredFiles, setFilteredFiles] = useState([]); //Status for filtered files


    const [optionJobs, setOptionJob] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const [isOpenMouldModal, setIsOpenMouldModal] = useState(false);
    const [getMouldFile, setGetMouldFile] = useState([]);


    const [formData, setFormData] = useState({
        id: onQuotationID,
        name: "",
        lastname: "",
        mat_id: 1,
        file_id: "",
        date_estimated: '',
        email: "",
        phone: "",
        phone2: "",
        address: "",
        city: "",
        zipcode: "",
        country: "",
        shipping_address: "",
        shipping_city: "",
        shipping_zipcode: "",
        shipping_country: "",
        contact_fullname: "",
        contact_phone: "",
        contact_email: "",
        comment: "",
        qty: 1,
        wax_qty: 0,
        items: [],
        volume: "",
        discount: 0,
        area: "",
        weight: "",
        dimensions: "",
        job_comment: "",
        reference1: "",
        reference2: "",
        quotj_ID: "",
        est_id: ""
    });

    const CHUNK_SIZE = 10240 * 10240;

    useEffect(() => {
        const fetchQuotation = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/quotations/select?id=${onQuotationID}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    console.log({ formData: data })
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        ...data,
                        wax_qty: 0,
                        qty: 1,
                        est_id: data.est_ID,
                        date_estimated: data.date_estimated,
                        cust_id: data.cust_ID
                    });

                    setCurrentCustomer(data.cust_ID)

                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false)
            }
        };

        setTimeout(() => {
            fetchQuotation();
        }, 300);

    }, [onQuotationID]);

    useEffect(() => {
        const getOptionJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_value/list`, headers);
                if (response.data.RES_CODE === "00") {

                    setOptionJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getOptionJob();
    }, []);

    useEffect(() => {
        const getBussinessLibrary = async () => {

            try {
                const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
                if (response.data.RES_CODE === "00") {

                    setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {

                        return b.file_ID - a.file_ID;


                    }));
                }
            } catch (error) {
                console.log(error)
            }
        }
        getBussinessLibrary();
    }, []);

    const getBussinessLibrary = async () => {

        try {
            const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
            if (response.data.RES_CODE === "00") {

                setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {

                    return b.file_ID - a.file_ID;


                }));
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getMouldLibrary = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/moulds/private/list`, headers);
            //console.log({ Mould: response.data });


            if (response.data.RES_CODE === "00") {
                setGetMouldFile(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleUploadFileModal = async () => {
        if (selectedFiles.length === 0) return;

        setIsUploading(true); //We show the progress bar


        const file = selectedFiles[0]; //We only upload the first file for now


        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        let fileName = file.name; //Original Name of the Archive



        try {
            //Verify if the file already exists



            try {
                const checkResponse = await axios.get(
                    `${server_backend}/files/private/exists?name=${file.name}`,
                    headers
                );

                if (checkResponse.data.RES_CODE === "00") {
                    //If it exists, add an alias based on the date and time



                    const now = new Date();
                    const year = String(now.getFullYear()).slice(2); //Obtain last 2 digits of the year


                    const month = String(now.getMonth() + 1).padStart(2, '0'); //month with 2 digits


                    const day = String(now.getDate()).padStart(2, '0'); //day with 2 digits


                    const hours = String(now.getHours()).padStart(2, '0'); //hour with 2 digits


                    const minutes = String(now.getMinutes()).padStart(2, '0'); //minutes with 2 digits


                    const seconds = String(now.getSeconds()).padStart(2, '0'); //seconds with 2 digits



                    //format the full date as yyymmddhhmms


                    const formattedDate = `${year}${month}${day}${hours}${minutes}${seconds}`;

                    //Obtain extension and base name of the file


                    const fileExtension = file.name.split('.').pop(); //file extension


                    const fileBaseName = file.name.replace(`.${fileExtension}`, ''); //Name without extension



                    //Create the new file name


                    fileName = `${fileBaseName}_${formattedDate}.${fileExtension}`;



                }
            } catch (error) {
                //Console.log(error)


            }


            for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, file.size);
                const chunk = file.slice(start, end);

                const formData = new FormData();
                formData.append('chunk', chunk);
                formData.append('chunkIndex', chunkIndex);
                formData.append('totalChunks', totalChunks);
                formData.append('name', fileName); //Use the name with alias if there is conflict


                formData.append('user_transaction', username);
                setAliasFileName(fileName);
                const uploadConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': headers.headers.Authorization,
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            ((chunkIndex + 1) / totalChunks) * 100
                        );
                        setUploadProgress(percentCompleted);
                    },
                };

                try {
                    const uploadResponse = await axios.post(
                        `${server_backend}/files/private/insert`,
                        formData,
                        uploadConfig
                    );

                    if (uploadResponse.data.RES_CODE === "00") {
                        setConfUpload(true);
                        setIsUploading(false); //We restart the state


                        setUploadProgress(0);
                        return; //end the function after the successful load


                    }
                } catch (uploadError) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error uploading file',
                        text: 'There was an issue uploading the file.',
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    setIsUploading(false);
                    setUploadProgress(0);
                    return; //We leave in case of error


                }
            }
        } catch (error) {
            console.error('Error checking file existence:', error);
        } finally {
            getBussinessLibrary(); //Update the library after loading


        }

        setIsUploading(false); //We hide the progress bar


        setUploadProgress(0); //We restart progress after loading


    };

    const fetchQuotation = async () => {
        try {
            const response = await axios.get(`${server_backend}/quotations/select?id=${onQuotationID}`, headers);
            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                //Console.log(response.data)


                setUserCreated(data.user_created);
                setUserModify(data.user_modify);
                setDateCreated(data.date_created);
                setDateModify(data.date_modify);

                setFormData({
                    ...data,
                    qty: 1,
                    wax_qty: 0,
                    est_id: formData.est_id ? formData.est_id : data.est_id,
                    date_estimated: data.date_estimated,
                    cust_id: data.cust_ID
                });

            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        //at the end (TRUE);



        //Console.log ({quotization: formdata, estatus: formdata.est_id});



        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/quotations/update`, {
                        ...formData,
                        id: onQuotationID,
                        est_id: formData.est_id
                    }, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        onClose();
                        getQuotations();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Quotation',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    console.log(error)
                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                }
            }
        }
        )
    };

    const handleFileSelect = (File) => {
        //console.log({ File: File })


        setSTLFileBussiness(File);
        setFileURL(File.path_File);
        setIsDropdownVisible(false);
    };

    const formatStats = (stats) => {
        const formatNumber = (num, decimals) => num.toFixed(decimals);
        //console.log("thi is format stats")


        const volume = formatNumber(stats.volume / 1000, 2);
        const area = formatNumber(stats.area / 100, 2);
        const weight = formatNumber(stats.weight / 1000, 2);

        const dimensions = {
            x: formatNumber(stats.dimensions.x / 10, 2),
            y: formatNumber(stats.dimensions.y / 10, 2),
            z: formatNumber(stats.dimensions.z / 10, 2)
        };

        stats.volume = volume;
        stats.area = area;
        stats.weight = weight;
        stats.file_id = STLfileBussiness.file_ID;
        stats.dimensions = `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`;
        //setFormData({volume: ...volume});



        return stats;

        /*return {
            volume: `${volume} cm³`,
            area: `${area} cm²`,
            weight: `${weight} g`,
            dimensions: `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`
        }; */
    };

    const handleStatsUpdate = (stats) => {
        const formattedStats = formatStats(stats);
        //Console.log(stats)


        setFormData(formattedStats);
    };

    const handleMaterialSelect = (material) => {
        setSelectedMaterial(material);
        setFormData({ ...formData, mat_id: material.mat_ID });
        setShowDropdown(false);
    };

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);
                    setFormData((prevData) => ({
                        ...prevData,
                        mat_id: response.data.RES_RESULT[0].mat_ID,
                    }));
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (isUpdateJob === 0) {  //It is with the objective of selecting the
            //first material when adding a new object


            getMaterial();
        }
    }, [isUpdateJob]);

    useEffect(() => {
        const getCustomer = async () => {
            try {
                const response = await axios.get(`${server_backend}/customers/files/list?id=${currentCustomer}`, headers);
                if (response.data.RES_CODE === "00") {
                    //console.log({ eo: response.data });


                    const data = (response.data.RES_RESULT)
                    setCustomerFile(data)
                }
            } catch (error) {
                console.log({ bobocliente: error })
            }
        }
        getCustomer();
    }, [currentCustomer]);

    /* const getCurrentFile = async (fileID) => {
         console.log({ fileID: fileID });
         try {
             const response = await axios.get(`${server_backend}/customers/files/list?id=${fileID}`, headers);
             if (response.data.RES_CODE === "00") {
                 const data = (response.data.RES_RESULT);
                 console.log({data: data});
                
                 setIsDropdownVisible(false);
             }
         } catch (error) {
console.log(error)
         }
     } */

    useEffect(() => {

        const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

        if (selectedMaterial) {
            setSelectedMaterial(selectedMaterial);
            setSelectedMaterialColor(selectedMaterial.color);
        }
    }, [STLfileBussiness, !isUpdateJob]);

    useEffect(() => {
        const getMaterialPrice = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);
                //console.log({ eo: response.data });



                if (response.data.RES_CODE === "00") {
                    setMaterialPrice(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMaterialPrice();
    }, []);

    useEffect(() => {
        if (selectedMaterial) {
            //const vw = formData.weight *selectedMaterial.density;


            const vw = formData.volume;
            const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);

            if (isUpdateJob === 0) {
                //If you are creating a new job, calculate the price


                setCurrentPrice(parseFloat(price).toFixed(2) || 0);
                //setFormData({ ...formData, price: price });


            }
        }
    }, [selectedMaterial, formData.weight, isUpdateJob, materialPrice]);


    useEffect(() => {
        const getStatusQuotation = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/quotation`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusQuotation();
    }, []);

    //These two hooks are used to correctly select the first material once the corresponding variables have been updated.


    useEffect(() => {
        if (materialList && materialList.length > 0 && formData.mat_id && !isInitialized) {

            const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

            if (selectedMaterial) {

                handleMaterialSelect(selectedMaterial);
                setSelectedMaterialColor(selectedMaterial.color);
                setCurrentDencity(selectedMaterial.density);

                setIsInitialized(false);
            }


        }
    }, [materialList, formData.mat_id, isInitialized, formData.qty, !isUpdateJob]);  

    useEffect(() => {
        if (isInitialized && selectedMaterial) {
            const vw = formData.weight * selectedMaterial.density;
            const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);

            if (isUpdateJob === 0) {
                setCurrentPrice(price || 0);
            }

        }
    }, [formData, materialPrice, selectedMaterial, isInitialized, !isUpdateJob]);
    //End



    const closeModalFile = () => {
        //Set stl file bussiness(null)


        cleanSTLFiles()
        setFileUploadlist(false)

    }

    const openModalFile = (item, firstFile) => {
        //console.log({ item: item })


        setFormData({
            ...formData,
            dated_estimated: '',
            designate: '',
            print_type: '',
            discount_ptg: '',
            job_comment: '',
            moulding: '',
            mould_only: '',
            sprue_master: '',
            sprue_material: '',
            sprue_feed: '',
            post: '',
            print_charge: '',
            wax_qty: '',
        });

        if (firstFile === true) {

            setIsUpdateJob(0);
            setFileUploadlist(true);
            /*  setFormData({
                 ...formData,
                 designate: '',
                 print_type: '',
                 discount_ptg: '',
                 moulding: '',
                 mould_only: '',
                 sprue_master: '',
                 sprue_material: '',
                 sprue_feed: '',
                 post: '',
                 print_charge: '',
                 wax_qty: '',
             }); */

        } else if (firstFile === false) {

            const added = true;
            setNanito(added);
            setIsUpdateJob(1);
            setSTLFileBussiness({
                ...item,
                name: item.file_name
            });
            setFileURL(`${server_backend}/${item.files_path_file}`);
            //Handle edit(index)



            setFileUploadlist(true);
            //console.log({ item: item });


            setFormData({
                ...formData,
                file_id: item.file_ID,
                parts: item.parts,
                date_estimated: item.date_estimated,
                price: item.price,
                qty: item.qty,
                job_comment: item.comment,
                volume: item.volume,
                comment: item.comment,
                discount: item.discount,
                area: item.area,
                dimensions: item.dimensions,
                mat_id: item.mat_ID,
                weight: item.weight,
                quotj_ID: item.quotj_ID,
                designate: item.designate,
                print_type: item.print_type,
                discount_ptg: parseFloat(item.discount_ptg || 0),
                moulding: item.moulding,
                mould_only: item.mould_only,
                sprue_master: item.sprue_master,
                sprue_material: item.sprue_material,
                sprue_feed: item.sprue_feed,
                post: item.post,
                print_charge: parseFloat(item.print_charge || 0).toFixed(2),
                wax_qty: item.wax_qty,

            });
            setCurrentPrice(item.price || 0);
        }

    }

    const OpenMouldModal = (item, firstFile) => {

        setFormData({
            ...formData,
            quotj_ID: '',
            file_id: '',
            mould_name: ''
        });

        if (firstFile === true) {
            setIsUpdateJob(0);

            //console.log({item: item});



            //Set file url(`${server backend}/${item.files path file}`);


            getMouldLibrary();
            setIsOpenMouldModal(true);

        } else {

            setIsUpdateJob(1);
            //console.log({ itemMould: item });


            setFormData({
                ...formData,
                mat_id: item.mat_ID,
                quotj_ID: item.quotj_ID,
                file_id: item.file_ID,
                mould_name: item.files_name,
                qty: item.qty
            });
            setFileURL(`${server_backend}/${item.files_path_file}`);
            getMouldLibrary();
            setIsOpenMouldModal(true);

        }
    }

    const calculatePrice = (formula, formDataWeight, materialPrice) => {
        console.log("Initial data:", { formula, formDataWeight, materialPrice });

        if (!formula || formula.trim() === '') return null;

        let processedFormula = formula.replace(/{weight}/g, parseFloat(formDataWeight));

        materialPrice.forEach((material) => {
            const variableName = material.name.toLowerCase();
            const materialPriceValue = parseFloat(material.lastprice || 0);
            if (!isNaN(materialPriceValue)) {
                processedFormula = processedFormula.replace(new RegExp(`{${variableName}}`, 'g'), materialPriceValue);
                console.log(`Replacing {${variableName}} with ${materialPriceValue}`);
            } else {
                console.warn(`Price not valid for ${material.name}`);
            }
        });

        console.log("Processed formula:", processedFormula);

        try {
            const price = new Function(`return (${processedFormula})`)();
            console.log("Calculated price:", price);
            return price;
        } catch (error) {
            console.log(error)
            console.error("Error in calculation:", error.message);
            return null;
        }
    };

    const UpdateFileToItems = async () => {
        //console.log({ hola: isUpdateJob })


        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                const newItem = {
                    volume: formData.volume,
                    area: formData.area,
                    parts: formData.parts || 1,
                    date_estimated: formData.date_estimated || new Date().toISOString().slice(0, 16),
                    weight: formData.weight,
                    dimensions: formData.dimensions,
                    job_comment: formData.job_comment,
                    file_id: STLfileBussiness.file_ID,
                    qty: formData.qty,
                    discount: formData.discount,
                    mat_id: formData.mat_id,
                    quot_id: onQuotationID,
                    price: currentPrice,
                    mount: currentPrice,
                    file_name: STLfileBussiness.name,
                    materialname: selectedMaterial.name,
                    designate: formData.designate,
                    print_type: formData.print_type,
                    discount_ptg: parseFloat(formData.discount_ptg || 0),
                    moulding: formData.moulding,
                    mould_only: formData.mould_only,
                    sprue_master: formData.sprue_master,
                    sprue_material: formData.sprue_material,
                    sprue_feed: formData.sprue_feed,
                    post: formData.post,
                    print_charge: parseFloat(formData.print_charge || 0).toFixed(2),
                    wax_qty: formData.wax_qty,
                    id: isUpdateJob === 0 ? onQuotationID : formData.quotj_ID //Be sure to include the Job ID


                };


                try {
                    if (isUpdateJob === 0) {
                        const response = await axios.post(`${server_backend}/quotations/jobs/insert`, newItem, headers);
                        if (response.data.RES_CODE === "00") {
                            Swal.fire({
                                icon: 'success',
                                title: 'Added Successfully',
                                showConfirmButton: false,
                                timer: 1000
                            });

                            fetchQuotation()
                            //Clean the fields


                            setFileUploadlist(false);
                            cleanSTLFiles()
                        }
                    } else {
                        const response = await axios.post(`${server_backend}/quotations/jobs/update`, newItem, headers);
                        if (response.data.RES_CODE === "00") {
                            Swal.fire({
                                icon: 'success',
                                title: 'Update Successfully',
                                showConfirmButton: false,
                                timer: 1000
                            });

                            fetchQuotation()
                            //Clean the fields


                            setSearchTerm("")
                            setFileUploadlist(false);
                            cleanSTLFiles()
                        }
                    }

                } catch (error) {
                    //Console.log(error)


                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }


            }

        }
        )


    };

    function cleanSTLFiles() {
        //Set selected material(null);


        setSTLFileBussiness([]);
        setSelectedFiles([]);
        setFormData((prevState) => ({
            ...prevState,
            qty: 1,
            price: 0,
            mat_id: ''
        }))
        //Close modal file();


    }

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        //Set stl file bussiness(selected file);


        const files = Array.from(event.target.files);
        setSelectedFiles(files);

        //const url = URL.createObjectURL(selectedFile);
        //setFileURL(url);


    };

    //handles the decrease in quantity


    const handleDecreaseQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            qty: Math.max(prevState.qty > 1 ? prevState.qty - 1 : 1)
        }));
    };

    //handle the quantity increase


    const handleIncreaseQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            qty: prevState.qty ? prevState.qty + 1 : 1
        }));
    };

    const handleDecreaseWaxQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            wax_qty: Math.max(prevState.wax_qty > 1 ? prevState.wax_qty - 1 : 0)
        }));
    };


    const handleIncreaseWaxQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            wax_qty: prevState.wax_qty ? prevState.wax_qty + 1 : 1
        }));
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;

        //Allows only numbers and a decimal point


        const cleanValue = value.replace(/[^0-9.]/g, '');

        //Verify that there is no more than a decimal point


        if ((cleanValue.match(/\./g) || []).length <= 1) {
            //Update the state without even parse to allow the point in real time


            setCurrentPrice(cleanValue || 0);
        }
    };

    //Calculate the total sub from formdata.jobs


    const calculateSubTotal = () => {
        if (formData.jobs && formData.jobs.length > 0) {
            return formData.jobs.reduce((acc, item) => acc + (item.price * item.qty), 0);
        }
        return 0;
    };

    const createJobs = () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const newItem = {
                    id: onQuotationID,
                    volume: formData.volume,
                    parts: formData.parts ? formData.parts : 1,
                    area: formData.area,
                    weight: formData.weight,
                    dimensions: formData.dimensions,
                    job_comment: formData.job_comment,
                    file_id: formData.file_id,
                    mat_id: selectedMaterial.mat_ID,
                    price: currentPrice || 0,
                    qty: formData.qty,
                    mount: currentPrice || 0,
                    filename: STLfileBussiness.name,
                    materialname: selectedMaterial.name,
                    discount: formData.discount || 0,
                    file_private: isPrivate,
                    urlfile: fileURL,
                    designate: formData.designate,
                    print_type: formData.print_type,
                    discount_ptg: parseFloat(formData.discount_ptg || 0),
                    moulding: formData.moulding,
                    mould_only: formData.mould_only,
                    sprue_master: formData.sprue_master,
                    sprue_material: formData.sprue_material,
                    sprue_feed: formData.sprue_feed,
                    post: formData.post,
                    print_charge: parseFloat(formData.print_charge || 0).toFixed(2),
                    wax_qty: formData.wax_qty,
                    date_estimated: formData.date_estimated,
                };
                console.log({ Items: newItem });
                try {
                    const response = await axios.post(`${server_backend}/quotations/jobs/insert`, newItem, headers);
                    //Console.log(response.data);


                    if (response.data.RES_CODE === "00") {

                        Swal.fire({
                            icon: 'success',
                            title: 'Created Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        setFormData({
                            ...formData,
                            file_id: '',
                            date_estimated: '',
                            qty: '',
                            job_comment: '',
                            volume: '',
                            comment: '',
                            discount: '',
                            area: '',
                            dimensions: '',
                            mat_id: '',
                            quotj_ID: '',
                            designate: '',
                            print_type: '',
                            discount_ptg: '',
                            moulding: '',
                            mould_only: '',
                            sprue_master: '',
                            sprue_material: '',
                            sprue_feed: '',
                            post: '',
                            print_charge: '',
                            wax_qty: '',
                        });

                        cleanSTLFiles()
                        fetchQuotation()
                        setFileUploadlist(false)
                        setLoading(false);

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {

                    fetchQuotation() //update quotation select



                }
            }
        }
        )



    };

    const deleteJob = async (jobID) => {
        //console.log({ jobID: jobID })


        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to delete this job? This action cannot be undone.",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/quotations/jobs/delete`, {
                        id: jobID
                    }, headers);
                    console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        fetchQuotation()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                    fetchQuotation() //update quotation select


                }
            }
        }
        )

    };

    const deleteMould = async (jobID) => {
        console.log({ jobID: jobID })
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to delete this mould? This action cannot be undone.",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/quotations/moulds/delete`, {
                        id: jobID
                    }, headers);
                    //Console.log(response.data);



                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        //Fetch quotation()


                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                    fetchQuotation() //update quotation select


                }
            }
        }
        )

    };

    //Filter files when changing the search term or file list


    useEffect(() => {
        if (getBussinessFiles && getBussinessFiles.length > 0) {
            const filtered = getBussinessFiles.filter(file =>
                file.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredFiles(filtered);
        } else {
            setFilteredFiles([]); //If there are no files, empty list


        }
    }, [searchTerm, getBussinessFiles]);


    const closeMouldModal = () => {
        setIsOpenMouldModal(false);
        setSearchTerm('');
    }

    const UpdateMouldModal = async () => {
        //console.log({ hola: isUpdateJob })


        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                const newItem = {
                    volume: formData.volume,
                    area: formData.area,
                    parts: formData.parts || 1,
                    date_estimated: formData.date_estimated || new Date().toISOString().slice(0, 16),
                    weight: formData.weight,
                    dimensions: formData.dimensions,
                    job_comment: formData.job_comment,
                    file_id: (STLfileBussiness && STLfileBussiness.file_ID) ? STLfileBussiness.file_ID : formData.file_id,
                    qty: formData.qty,
                    discount: formData.discount,
                    mat_id: formData.mat_id ? formData.mat_id : selectedMaterial.mat_ID,
                    quot_id: onQuotationID,
                    price: "0",
                    mount: "0",
                    file_name: formData.name,
                    materialname: selectedMaterial.name,
                    designate: formData.designate,
                    file_private: 1,
                    print_type: formData.print_type,
                    discount_ptg: formData.discount_ptg ? parseFloat(formData.discount_ptg || 0) : null,
                    moulding: formData.moulding,
                    mould_only: formData.mould_only,
                    sprue_master: formData.sprue_master,
                    sprue_material: formData.sprue_material,
                    sprue_feed: formData.sprue_feed,
                    post: formData.post,
                    print_charge: formData.print_charge ? parseFloat(formData.print_charge || 0).toFixed(2) : null,
                    wax_qty: formData.wax_qty,
                    id: isUpdateJob === 0 ? onQuotationID : formData.quotj_ID, //Be sure to include the Job ID


                };
            
                try {
                    if (isUpdateJob === 0) {
                        const response = await axios.post(`${server_backend}/quotations/moulds/insert`, newItem, headers);
                        //Console.log(response.data);


                        if (response.data.RES_CODE === "00") {
                            Swal.fire({
                                icon: 'success',
                                title: 'Added Successfully',
                                showConfirmButton: false,
                                timer: 1000
                            });

                            fetchQuotation()
                            //Clean the fields
                            //cleanSTLFiles()


                            setFileUploadlist(false);
                            setIsOpenMouldModal(false);
                        }
                    } else {
                        const response = await axios.post(`${server_backend}/quotations/moulds/update`, newItem, headers);
                        
                        if (response.data.RES_CODE === "00") {
                            Swal.fire({
                                icon: 'success',
                                title: 'Update Successfully',
                                showConfirmButton: false,
                                timer: 1000
                            });

                            fetchQuotation()
                            //Clean the fields


                            setFileUploadlist(false);
                            setSearchTerm("")
                            setIsOpenMouldModal(false);
                            cleanSTLFiles()
                        }
                    }

                } catch (error) {
                    //Console.log(error)


                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }


            }

        }
        )


    };

    return (
        <div className="row">
            <div className="card">
                <div className="card-header align-items-center d-flex">
                    <div className="col-12">
                        <div className="row">
                            <div className="hstack gap-2 justify-content-end d-print-none mt-4">

                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            onClose();
                                        }
                                    }
                                    )
                                }
                                }>Discard Change</Link>

                                <button type="button" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                            </div>

                            <center><h5>Instant Quote ID: <Link>{onQuotationID}</Link></h5></center>
                        </div>
                    </div>

                </div>
                <div className="modal-body">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-bottom-dashed p-4">
                                    <div className="d-sm-flex">
                                        <div className="flex-grow-1">
                                            <img src="assets/images/dbclogo.jpg" alt="" height="40" />
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="mt-sm-5 mt-4">
                                                            <h6 className="text-muted text-uppercase fw-semibold">Address</h6>
                                                            <p className="text-muted mb-1" id="address-details">Design Build Cast Ltd
                                                                Unit 3.01,</p>
                                                            <p className="text-muted mb-0">The Goldsmiths Centre,</p>
                                                            <p className="text-muted mb-0">42 Britton Street,
                                                                London EC1M 5AD</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mt-sm-5 mt-4">
                                                            <h6 className="text-muted text-uppercase fw-semibold">Review Information</h6>
                                                            {formData.user_close && (
                                                                <>
                                                                    <p className="text-muted mb-0 fs-25" >Reviewed by: {formData.user_close}</p>
                                                                    <p className="text-muted mb-1" id="address-details">{vAdminformat.FormatDate(formData.date_close)}</p>

                                                                    <p className="text-muted mb-0">{formData.comment_close}</p>
                                                                </>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex-shrink-0 mt-sm-0 mt-3">
                                            <h6><span className="text-muted fw-normal">Email:</span> <span id="email">enquiries@designbuildcast.co.uk</span></h6>
                                            <h6><span className="text-muted fw-normal">Website:</span> <a href="https://enquiries@designbuildcast.co.uk/" className="link-primary" target="_blank" id="website">designbuildcast.co.uk</a></h6>
                                            <h6 className="mb-0"><span className="text-muted fw-normal">Contact No: </span><span id="contact-no">0207 608 2228
                                            </span></h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body p-4">
                                    <div className="row g-3">
                                        <div className="col-lg-3 col-sm-6">
                                            <label for="invoicenoInput">Instant Quote No</label>

                                            <p className="text-muted mb-0 fs-25" >{formData.quot_ID}</p>
                                            {/* <input type="text" className="form-control  border-0" id="invoicenoInput" value={`#${formData.quot_ID}`} disabled /> 
                                           */}
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <div>
                                                <label for="date-field">Date</label>

                                                <p className="text-muted mb-0 fs-25" >{vAdminformat.FormatDate(dateCreated)} </p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <div>
                                                <label for="totalamountInput">Total Amount</label>
                                                <p className="text-muted mb-0 fs-25"> {`${vAdminformat.FormatMoney(calculateSubTotal() +
                                                    calculateSubTotal() * 0.20 -
                                                    (calculateSubTotal() * (formData.discount / 100) || 0)
                                                )}`} </p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <label htmlFor="choices-payment-status">Status</label>
                                            <div className="input-light">
                                                <select
                                                    className="form-control bg-light border-0"
                                                    id="choices-payment-status"
                                                    required
                                                    value={formData.est_id || formData.est_ID || ''}
                                                    onChange={(e) => setFormData({ ...formData, est_id: e.target.value })}
                                                >
                                                    <option value="">Select Status</option>
                                                    {statusQuot.map((status) => (
                                                        <option key={status.est_ID} value={status.est_ID}>
                                                            {status.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                <div className="card-body p-4 border-top border-top-dashed">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-lg-6 col-sm-6">

                                                <div className='mb-3'>
                                                    <label for="billingName" className="text-muted text-uppercase fw-semibold">Customer Information</label>
                                                </div>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>ID:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.cust_ID}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Full name:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.fullname}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Email:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.email}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Phone 1:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.phone}
                                                                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Phone 2:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.phone2}
                                                                        onChange={(e) => setFormData({ ...formData, phone2: e.target.value })}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                )}


                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <div className='mb-3'>
                                                    <label for="shippingName" className="text-muted text-uppercase fw-semibold">Customer Address
                                                    </label>
                                                </div>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Address:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}><input type="text"
                                                                    className="form-control bg-light border-0"
                                                                    data-plugin="cleave-phone" id="billingPhoneno"

                                                                    value={formData.address}
                                                                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                                /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>City:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"

                                                                        value={formData.city}
                                                                        onChange={(e) => setFormData({ ...formData, city: e.target.value })} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Country:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"

                                                                        value={formData.country}
                                                                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                                                    /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Post Code:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"
                                                                        value={formData.zipcode}
                                                                        onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })} /></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="card-body p-4 justify-content-end">
                                    <div className="table-responsive">
                                        <table className="invoice-table table table-borderless table-nowrap mb-0">
                                            <thead className="align-middle">
                                                <tr className="table-active">
                                                    <th scope="col" style={{ width: "50px" }}>#</th>
                                                    <th scope="col">Image</th>
                                                    <th scope="col">
                                                        Product Details
                                                    </th>
                                                    <th scope="col" style={{ width: "120px" }}>
                                                        <div className="d-flex currency-select input-light align-items-center">
                                                            Material
                                                        </div>
                                                    </th>
                                                    <th scope="col" style={{ width: "120px" }}>
                                                        <div className="d-flex currency-select input-light  text-end justify-content-end">
                                                            Price
                                                        </div>
                                                    </th>

                                                    <th scope="col" style={{ width: "120px" }}>
                                                        <center>Quantity</center></th>
                                                    <th scope="col" style={{ width: "60px" }}>
                                                        <center>Discount</center></th>
                                                    <th scope="col" className="text-end" style={{ width: "150px" }}>Total</th>
                                                    <th scope="col" className="text-end" style={{ width: "105px" }}></th>
                                                </tr>
                                            </thead>
                                            <tbody id="newlink">
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan="8">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless mb-0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {/* Jobs Section */}
                                                        {formData.jobs && formData.jobs.length > 0 ? (
                                                            formData.jobs.map((item, index) => (
                                                                <tr key={`job-${index}`} className="product">
                                                                    <th scope="row" className="product-id">{index + 1}</th>
                                                                    <td>
                                                                        <div style={{ height: "13vh", width: "13vh" }}>
                                                                            <SimpleSTLViewer url={`${server_backend}/${item.files_path_file}`} />
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-start">
                                                                        <span className="fw-medium">STL File</span>
                                                                        <p
                                                                            className="text-muted mb-0 text-truncate"
                                                                            style={{ maxWidth: '250px' }}
                                                                            title={item.file_name}
                                                                        >
                                                                            Uploaded file: {item.file_name}
                                                                        </p>

                                                                        <p className="text-muted mb-0">Volume: {item.volume} cm³ / Area: {item.area}</p>
                                                                        <p className="text-muted mb-0">Weight: {item.weight}</p>
                                                                    </td>
                                                                    <td>
                                                                        <span className="fw-medium">{item.materials_name}</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex justify-content-end">
                                                                            <span>{vAdminformat.FormatMoney(item.price)}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='d-flex justify-content-center'>
                                                                            <span className="fw-medium">{item.qty}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <span>{vAdminformat.FormatMoney(item.discount)}</span>
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <span>{vAdminformat.FormatMoney(item.subtotal)}</span>
                                                                    </td>
                                                                    <td className="product-removal d-flex gap-2">
                                                                        <button
                                                                            className="btn btn-outline-primary"
                                                                            type="button"
                                                                            onClick={() => openModalFile(item, false)}
                                                                        >
                                                                            <i className="bx bx-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-outline-danger"
                                                                            type="button"
                                                                            onClick={() => deleteJob(item.quotj_ID)}
                                                                        >
                                                                            <i className="bx bx-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9" className="text-center text-muted">No STL jobs available.</td>
                                                            </tr>
                                                        )}

                                                        {/* Molds Section */}
                                                        {formData.moulds && formData.moulds.length > 0 ? (
                                                            formData.moulds.map((item, index) => (
                                                                <tr key={`mold-${index}`} className="product">
                                                                    <th scope="row" className="product-id">{index + 1}</th>
                                                                    <td>
                                                                        <div style={{ height: "13vh", width: "13vh" }}>
                                                                            {getFileExtension(item.files_path_file) === "stl" ? (
                                                                                <SimpleSTLViewer url={`${server_backend}/${item.files_path_file}`} />
                                                                            ) : (

                                                                                <img src={`${server_backend}/${item.files_path_file}`} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />

                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-start">
                                                                        <span className="fw-medium">Mould</span>
                                                                        <p className="text-muted mb-0">Uploaded file: {item.file_name}</p>

                                                                    </td>
                                                                    <td>
                                                                        <span className="fw-medium">{item.materials_name}</span>
                                                                    </td>
                                                                    <td>
                                                                        {/* <div className="d-flex justify-content-end">
                                                                            <span>{vAdminformat.FormatMoney(item.price)}</span>
                                                                        </div> */}
                                                                    </td>
                                                                    <td>
                                                                        <div className='d-flex justify-content-center'>
                                                                            <span className="fw-medium">{item.qty}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {/*  <span>{v adminformat.format money(item.discount)}</span> */}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {/*    <span>{v adminformat.format money(item.subtotal)}</span> */}
                                                                    </td>
                                                                    <td className="product-removal d-flex gap-2">
                                                                        <button
                                                                            className="btn btn-outline-primary"
                                                                            type="button"
                                                                            onClick={() => OpenMouldModal(item, false)}
                                                                        >
                                                                            <i className="bx bx-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-outline-danger"
                                                                            type="button"
                                                                            onClick={() => deleteMould(item.quotj_ID)}
                                                                        >
                                                                            <i className="bx bx-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9" className="text-center text-muted">No moulds available.</td>
                                                            </tr>
                                                        )}
                                                    </>
                                                )}
                                            </tbody>

                                            <tr id="newForm" style={{ display: "none" }}></tr>
                                            <tr>
                                                <td colspan="9">
                                                    <button type='button' id="add-item" className="btn btn-soft-secondary fw-medium" onClick={() => {
                                                        openModalFile(null, true)
                                                    }
                                                    }><i className="ri-add-fill me-1 align-bottom" ></i> Add Item</button>
                                                    <button type='button' id="add-item" className="btn btn-soft-success fw-medium" onClick={() => {
                                                        OpenMouldModal(null, true)
                                                    }
                                                    }><i className="ri-add-fill me-1 align-bottom" ></i> Add Mould</button>

                                                </td>
                                            </tr>

                                        </table>
                                    </div>
                                    <div className="border-top border-top-dashed mt-2 d-flex justify-content-end">
                                        <div className="col-auto">
                                            <table className="table table-borderless text-start table-nowrap align-middle mb-0">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row" className="p-2 text-muted fs-5">Sub Total </th>
                                                        <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(formData.subtotal_summary)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="p-2 text-muted fs-5">Discount Total </th>
                                                        <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(formData.discount_summary)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="p-2 text-muted fs-5">VAT Total </th>
                                                        <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(formData.taxtotal_summary)}</td>
                                                    </tr>
                                                    <tr className="border-top border-top-dashed">
                                                        <th scope="row" className="p-2 text-muted fs-5">Total</th>
                                                        <td className="p-0 text-end fw-medium fs-5">{vAdminformat.FormatMoney(formData.total_summary)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <br />
                                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">

                                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {

                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Alert',
                                                text: "Are you sure you want to discard these changes?",
                                                showCancelButton: true,
                                                confirmButtonText: 'Accept',
                                                cancelButtonText: "Cancel"
                                            }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                    onClose();
                                                }
                                            }
                                            )
                                        }
                                        }>Discard Change</Link>

                                        <button type="button" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={`modal fade ${fileUploadList ? 'show' : ''}`} style={{ display: fileUploadList ? 'block' : 'none', backgroundColor: "#0000007a" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myExtraLargeModalLabel">{isUpdateJob === 1 ? "Update Job" : "Create Job"}</h5>
                                <button type="button" className="btn-close" onClick={closeModalFile} aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ minHeight: "80vh" }}>
                                <div id="paymentAccordion">
                                    {isUpdateJob === 0 && (
                                        <div className="row">
                                            <div className="col-lg-4 col-sm-6">
                                                <div className="form-check card-radio">
                                                    <input
                                                        id="paymentMethod01"
                                                        name="paymentMethod"
                                                        type="radio"
                                                        className="form-check-input"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#paymentmethodCollapseCustomerFile"
                                                        aria-expanded="false"
                                                        aria-controls="paymentmethodCollapseCustomerFile"
                                                        onClick={() => {
                                                            setSTLFileBussiness(null);
                                                            setConfUpload(false);
                                                            setIsPrivate(0)
                                                            setSelectedFiles([]);
                                                            setFormData({
                                                                ...formData,
                                                                volume: "",
                                                                area: "",
                                                                weight: "",
                                                                file_id: "",
                                                                dimensions: ""
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="paymentMethod01">
                                                        <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                        <span className="fs-15 text-wrap"> All Files</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="form-check card-radio">
                                                    <input
                                                        id="paymentMethod02"
                                                        name="paymentMethod"
                                                        type="radio"
                                                        className="form-check-input"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#paymentmethodCollapseMyLibrary"
                                                        aria-expanded="false"
                                                        aria-controls="paymentmethodCollapseMyLibrary"
                                                        onClick={() => {
                                                            setSTLFileBussiness(null);
                                                            setConfUpload(false);
                                                            setSelectedFiles([]);
                                                            setIsPrivate(1);
                                                            setFormData({
                                                                ...formData,
                                                                volume: "",
                                                                area: "",
                                                                weight: "",
                                                                file_id: "",
                                                                dimensions: ""
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="paymentMethod02">
                                                        <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                        <span className="fs-15 text-wrap">Print Folder</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="form-check card-radio">
                                                    <input
                                                        id="paymentMethod03"
                                                        name="paymentMethod"
                                                        type="radio"
                                                        className="form-check-input"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#paymentmethodCollapseUploadFile"
                                                        aria-expanded="false"
                                                        aria-controls="paymentmethodCollapseUploadFile"
                                                        onClick={() => {
                                                            setSTLFileBussiness(null);
                                                            setConfUpload(false);
                                                            setSelectedFiles([]);
                                                            setFormData({
                                                                ...formData,
                                                                volume: "",
                                                                area: "",
                                                                weight: "",
                                                                file_id: "",
                                                                dimensions: ""
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="paymentMethod03">
                                                        <span className="fs-16 text-muted me-2"><i className="ri-upload-2-line"></i></span>
                                                        <span className="fs-15 text-wrap">Upload File</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="collapse show" id="paymentmethodCollapseCustomerFile" data-bs-parent="#paymentAccordion">
                                        <div style={{ marginBlock: "1em" }}>
                                           {isUpdateJob === 0 && (
    <div className="mb-3 position-relative">
        <label htmlFor="select-existing-customer" className="form-label">Print Folder</label>
        <input
            type="text"
            className="form-control"
            id="select-existing-customer"
            placeholder="Select or search for a File..."
            onFocus={() => setIsDropdownVisible(true)}
            onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)} 

        />

        {isDropdownVisible && (
            <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {customerFiles?.length > 0 ? (
                    customerFiles.map((CustomerFile) => (
                        <button
                            className="dropdown-item"
                            type="button"
                            key={CustomerFile.id || CustomerFile.name}
                            onClick={() => {
                                handleFileSelect(CustomerFile);
                                setFileURL(`${server_backend}/${CustomerFile.path_file}`);
                                setIsDropdownVisible(false); // close dropdown after selecting


                            }}
                        >
                            {CustomerFile.name}
                        </button>
                    ))
                ) : (
                    <button className="dropdown-item" type="button" disabled>
                        No File found
                    </button>
                )}
            </div>
        )}
    </div>
)}


                                            <div className="row">

                                                <div className="col-lg-6 col-md-12">
                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                            <div>
                                                                <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                            </center>
                                                            <div
                                                                style={{
                                                                    minHeight: '23vh',
                                                                    height: '22vh',
                                                                    border: '1px solid #dcdcdc',
                                                                    padding: "20px",
                                                                    width: "100%",
                                                                    backgroundColor: "#fff",
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {materialList && materialList.length > 0 ? (
                                                                    materialList.map((material) => (
                                                                        <button
                                                                            key={material.mat_ID}
                                                                            className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                            type="button"
                                                                            onClick={() => {

                                                                                handleMaterialSelect(material);
                                                                                setSelectedMaterialColor(material.color);
                                                                                setCurrentDencity(material.density);


                                                                            }}
                                                                        >
                                                                            <div className="d-flex align-items-center">
                                                                                <ColorBox color={material.color} />
                                                                                <span className="ms-2">{material.name}</span>
                                                                            </div>
                                                                        </button>
                                                                    ))
                                                                ) : (
                                                                    <button className="dropdown-item" type="button" disabled>
                                                                        No materials found
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                            </center>
                                                            <div className="table-responsive" style={{ width: '100%', height: '42vh', overflow: "hidden" }}>
                                                                <table className="table table-bordered" style={{ height: '23vh' }}>
                                                                    <tbody>

                                                                        <tr>
                                                                            <td className="font-weight-bold">
                                                                                <h6>Weight (g):</h6>
                                                                            </td>
                                                                            <td className="text-end" style={{ width: "20%" }}>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control text-center small-input"
                                                                                    id="weightInput"
                                                                                    placeholder="Enter weight in grams"
                                                                                    value={formData.weight}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, weight: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="font-weight-bold">
                                                                                <h6>Dimensions (mm):</h6>
                                                                            </td>
                                                                            <td className="text-end">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-center small-input"
                                                                                    id="dimensionsInput"
                                                                                    placeholder="Enter dimensions in mm"
                                                                                    value={formData.dimensions}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, dimensions: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>

                                                                    </tbody>

                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="collapse" id="paymentmethodCollapseMyLibrary" data-bs-parent="#paymentAccordion">

                                        <div style={{ marginBlock: "1em" }}>
                                            {isUpdateJob === 0 ? (
    <div className="mb-3 position-relative" style={{ zIndex: 10 }}>
        <label htmlFor="select-existing-customer" className="form-label">
            Print Folder
        </label>
        <input
            type="text"
            className="form-control"
            id="select-existing-customer"
            placeholder="Select or search for a File..."
            onFocus={() => setIsDropdownVisible(true)}
            onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)} // Hide when losing focus
            onChange={(e) => setSearchTerm(e.target.value)} // Update the search term
            value={searchTerm}
            autoComplete="off"
        />

        {isDropdownVisible && (
            <div
                className="dropdown-menu show w-100"
                style={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    zIndex: 1000,
                }}
            >
                {filteredFiles.length > 0 ? (
                    filteredFiles.map((bussinessFile) => (
                        <button
                            className="dropdown-item"
                            type="button"
                            key={bussinessFile.id || bussinessFile.name}
                            onClick={() => {
                                handleFileSelect(bussinessFile);
                                setSearchTerm(bussinessFile.name); // Update Input with the selected file
                                setFileURL(`${server_backend}/${bussinessFile.path_file}`);
                                setIsDropdownVisible(false); // Hide list
                            }}
                        >
                            {bussinessFile.name}
                        </button>
                    ))
                ) : (
                    <button className="dropdown-item" type="button" disabled>
                        No File found
                    </button>
                )}
            </div>
        )}
    </div>
) : null}


                                            <div className="row">

                                                <div className="col-lg-6 col-md-12">
                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                            <div>
                                                                <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                            </center>
                                                            <div
                                                                style={{
                                                                    minHeight: '23vh',
                                                                    height: '22vh',
                                                                    border: '1px solid #dcdcdc',
                                                                    padding: "20px",
                                                                    width: "100%",
                                                                    backgroundColor: "#fff",
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {materialList && materialList.length > 0 ? (
                                                                    materialList.map((material) => (
                                                                        <button
                                                                            key={material.mat_ID}
                                                                            className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                            type="button"
                                                                            onClick={() => {

                                                                                handleMaterialSelect(material);
                                                                                setSelectedMaterialColor(material.color);
                                                                                setCurrentDencity(material.density);


                                                                            }}
                                                                        >
                                                                            <div className="d-flex align-items-center">
                                                                                <ColorBox color={material.color} />
                                                                                <span className="ms-2">{material.name}</span>
                                                                            </div>
                                                                        </button>
                                                                    ))
                                                                ) : (
                                                                    <button className="dropdown-item" type="button" disabled>
                                                                        No materials found
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                            </center>
                                                            <div className="table-responsive" style={{ width: '100%', height: '42vh', overflow: "hidden" }}>
                                                                <table className="table table-bordered" style={{ height: '23vh' }}>
                                                                    <tbody>

                                                                        <tr>
                                                                            <td className="font-weight-bold">
                                                                                <h6>Weight (g):</h6>
                                                                            </td>
                                                                            <td className="text-end" style={{ width: "20%" }}>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control text-center small-input"
                                                                                    id="weightInput"
                                                                                    placeholder="Enter weight in grams"
                                                                                    value={formData.weight}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, weight: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="font-weight-bold">
                                                                                <h6>Dimensions (mm):</h6>
                                                                            </td>
                                                                            <td className="text-end">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-center small-input"
                                                                                    id="dimensionsInput"
                                                                                    placeholder="Enter dimensions in mm"
                                                                                    value={formData.dimensions}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, dimensions: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>

                                                                    </tbody>

                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>

                                            </div>


                                        </div>
                                    </div>

                                    <div className="collapse" id="paymentmethodCollapseUploadFile" data-bs-parent="#paymentAccordion">

                                        {ConfUpload ? (
                                            <div class="alert alert-success alert-dismissible fade show" style={{ marginBlock: "2em" }} role="alert">
                                                <strong>The file has been successfully uploaded!</strong> You can locate it in the 'Print Folder' under the name <strong>{AliasFileName}</strong>.
                                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                            </div>

                                        ) : (
                                            <div style={{ marginBlock: "2em" }}>
                                                <div >
                                                    <label htmlFor="formFile" className="form-label">Upload Your File</label>
                                                    <input className="form-control" type="file" id="formFile" accept=".stl" onChange={handleFileChange} />
                                                </div>

                                                {selectedFiles.length > 0 && (
                                                    <div className="mt-3">
                                                        <h6>Selected Files:</h6>
                                                        <ul className="list-group">
                                                            {selectedFiles.map((file, index) => (
                                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                                    {file.name}
                                                                    <span className="badge bg-primary rounded-pill">{Math.round(file.size / 1024)} KB</span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}

                                                {isUploading && (
                                                    <div className="progress mt-3">
                                                        <div
                                                            className="progress-bar progress-bar-striped progress-bar-animated"
                                                            role="progressbar"
                                                            aria-valuenow={uploadProgress}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                            style={{ width: `${uploadProgress}%` }}
                                                        >
                                                            {uploadProgress}%
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="mt-3">
                                                    <button className="btn btn-primary w-100" onClick={handleUploadFileModal} disabled={isUploading}>
                                                        {isUploading ? 'Uploading...' : 'Upload and Save'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                        <div className="row">
                                            {/*Quantity Field */}
                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="quantityInput" className="form-label">Quantity</label>
                                                <div className="input-step d-flex align-items-center w-100">
                                                    <button type="button" className="minus" onClick={() => handleDecreaseQuantity()}>–</button>
                                                    <input
                                                        type="number"
                                                        className="text-center mx-2 product-quantity w-100"
                                                        value={formData.qty ? formData.qty : 1}
                                                        min="0"
                                                        max="100"
                                                        readOnly
                                                    />
                                                    <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseQuantity()}>+</button>
                                                </div>
                                            </div>

                                            {/*Price Field */}
                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="priceInput" className="form-label">Price</label>

                                                <input type="number" class="form-control" value={currentPrice} required
                                                    onChange={handlePriceChange} />
                                            </div>

                                            {/* Discount */}

                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="priceInput" className="form-label">Discount</label>
                                                <div className="input-group">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="cart-discount"

                                                        onKeyUp={(e) => {

                                                            let value = 0;

                                                            if (e.target.value == '') {
                                                                value = 0;
                                                                e.target.value = 0;
                                                                setFormData({ ...formData, discount: value });
                                                            } else {
                                                                e.target.value = parseInt(e.target.value);
                                                                setFormData({ ...formData, discount: parseInt(e.target.value) });
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/*Total Field */}
                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="totalInput" className="form-label">Total</label>
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    id="totalInput"
                                                    value={vAdminformat.FormatMoney(
                                                        (currentPrice * formData.qty) - (formData.discount || 0)
                                                    )}
                                                    readOnly
                                                    disabled
                                                />

                                            </div>

                                            {/* Aditional information  */}
                                            <div>
                                                <h5 style={{ paddingBlock: "18px" }}>Additional Information</h5>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">3D Print</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.print_type}
                                                                onChange={(e) => setFormData({ ...formData, print_type: e.target.value })}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 1)
                                                                        .map(option => [option.name, option])
                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Print Charge (£)</label>
                                                            <div className="position-relative">

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter amount or select an option"
                                                                    value={formData.print_charge || ""}
                                                                    onKeyDown={() => setShowOptions(false)}
                                                                    onChange={(e) => {
                                                                        setFormData({
                                                                            ...formData,
                                                                            print_charge: e.target.value,
                                                                        });
                                                                    }}
                                                                    onFocus={() => setShowOptions(true)}
                                                                />


                                                                {showOptions && (
                                                                    <div
                                                                        className="dropdown-menu show position-absolute w-100 mt-1"
                                                                        style={{
                                                                            maxHeight: "200px",
                                                                            overflowY: "auto",
                                                                            zIndex: 1050,
                                                                        }}
                                                                    >
                                                                        {[...new Map(
                                                                            optionJobs
                                                                                .filter(option => option.optjc_ID === 2)
                                                                                .map(option => [option.name, option])
                                                                        ).values()].map((uniqueOption) => (
                                                                            <button
                                                                                key={uniqueOption.optjc_ID}
                                                                                className="dropdown-item"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    setFormData({
                                                                                        ...formData,
                                                                                        print_charge: uniqueOption.value,
                                                                                    });
                                                                                    setShowOptions(false);
                                                                                }}
                                                                            >
                                                                                {uniqueOption.name}
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Print Discount (%)</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.discount_ptg}
                                                                onChange={(e) => setFormData({ ...formData, discount_ptg: e.target.value })}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 3)
                                                                        .map(option => [option.name, option])
                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.value} onClick={() => {
                                                                        setFormData({
                                                                            ...formData,
                                                                            discount_ptg: uniqueOption.value,
                                                                        });
                                                                        setShowOptions(false);
                                                                    }}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Moulding</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.moulding}
                                                                onChange={(e) => setFormData({ ...formData, moulding: e.target.value })}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 4)
                                                                        .map(option => [option.name, option])
                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Mould Only</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.mould_only}
                                                                onChange={(e) => setFormData({ ...formData, mould_only: e.target.value })}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 5)
                                                                        .map(option => [option.name, option])
                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="name" className="form-label">Quantity or Designate </label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="name"
                                                                    name="name"
                                                                    value={formData.designate}
                                                                    onChange={(e) => setFormData({ ...formData, designate: e.target.value })}
                                                                    required
                                                                />

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Expected Cast Date</label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                id="name"
                                                                name="name"
                                                                value={formData.date_estimated}
                                                                onChange={(e) => setFormData({ ...formData, date_estimated: e.target.value })}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="quantityInput" className="form-label">Injection Wax Quantity</label>
                                                        <div className="input-step d-flex align-items-center w-100">
                                                            <button type="button" className="minus btn btn-light" onClick={() => handleDecreaseWaxQuantity()}>–</button>
                                                            <input
                                                                type="number"
                                                                className="form-control text-center mx-2 product-quantity w-100"
                                                                value={formData.wax_qty ? formData.wax_qty : 0}
                                                                min="0"
                                                                max="100"
                                                            />

                                                            <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseWaxQuantity()}>+</button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Sprue Master</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.sprue_master}
                                                                onChange={(e) => setFormData({ ...formData, sprue_master: e.target.value })}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 6)
                                                                        .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate


                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.value}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Sprue Material</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.sprue_material}
                                                                onChange={(e) => setFormData({ ...formData, sprue_material: e.target.value })}
                                                                disabled={formData.sprue_master == 1 ? false : true}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 7)
                                                                        .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate


                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Metal</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.sprue_feed}
                                                                onChange={(e) => setFormData({ ...formData, sprue_feed: e.target.value })}
                                                                disabled={formData.sprue_master == 1 ? false : true}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 8)
                                                                        .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate


                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <label htmlFor="optjc_id" className="form-label">Post</label>
                                                            <select
                                                                className="form-select"
                                                                aria-label=".form-select-sm example"
                                                                name="optjc_id"
                                                                value={formData.post}
                                                                onChange={(e) => setFormData({ ...formData, post: e.target.value })}
                                                            ><option>Select the option</option>
                                                                {[...new Map(
                                                                    optionJobs
                                                                        .filter(option => option.optjc_ID === 9)
                                                                        .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate


                                                                ).values()].map(uniqueOption => (
                                                                    <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                        {uniqueOption.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}

                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label htmlFor="jobComment">Comments:</label>
                                                    <textarea
                                                        id="jobComment"
                                                        className="form-control"
                                                        value={formData.job_comment}
                                                        onChange={(e) => setFormData({ ...formData, job_comment: e.target.value })}
                                                        placeholder="Add your comments here"
                                                        rows="5"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}


                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                        <div className="col-12">
                                            <div className="card border-light shadow-sm mb-3" style={{ marginBlock: "10px", border: '1px solid #dcdcdc' }}>
                                                <div className="card-body d-flex justify-content-end align-items-center flex-wrap">
                                                    {isUpdateJob === 0 ? (<button
                                                        className="btn btn-primary w-25"
                                                        onClick={createJobs}
                                                    >
                                                        Save
                                                    </button>) : (<button
                                                        className="btn btn-primary w-25"
                                                        onClick={UpdateFileToItems}
                                                    >
                                                        Save
                                                    </button>)}


                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className={`modal fade ${isOpenMouldModal ? 'show' : ''}`}
                    style={{ display: isOpenMouldModal ? 'block' : 'none', backgroundColor: "#0000007a" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered modal-sm" style={{ maxWidth: "40%" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add injected wax media from your library to your Quote</h5>
                                <button type="button" className="btn-close" onClick={closeMouldModal} aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ minHeight: "80vh" }}>
                                <div className="row">
                                    <div className="col-12 mb-3">

                                        {isUpdateJob === 0 ? (
                                            <>
                                                <label className="form-label fw-bold text-muted">Mould library</label>
                                                <div className="d-flex">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="select-existing-customer"
                                                        placeholder="Select or search for a File..."
                                                        onFocus={() => setIsDropdownVisible(true)}
                                                        onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)} //Hide when losing focus


                                                        onChange={(e) => setSearchTerm(e.target.value)} //Update the search term


                                                        value={searchTerm || formData.mould_name} //Update Input with the selected file 


                                                    />
                                                    {isDropdownVisible && (
                                                        <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                            {getMouldFile && getMouldFile.length > 0 ? (
                                                                getMouldFile.map((mould) => (
                                                                    <button className="dropdown-item" type="button" key={mould.file_ID} onClick={() => {
                                                                        handleFileSelect(mould);
                                                                        setIsDropdownVisible(false); // Hide the dropdown after selection


                                                                        setSearchTerm(mould.name); //Update Input with the selected file


                                                                        setFileURL(`${server_backend}/${mould.path_file}`)
                                                                    }
                                                                    }>
                                                                        {mould.name}
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No File found
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        ) : null}
                                    </div>

                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold text-muted">Metal</label>
                                        <div
                                            style={{
                                                minHeight: '14vh',
                                                height: '14vh',
                                                border: '1px solid #dcdcdc',
                                                padding: "5px",
                                                width: "100%",
                                                backgroundColor: "#fff",
                                                overflowY: 'auto',
                                            }}
                                        >
                                            {materialList && materialList.length > 0 ? (
                                                materialList.map((material) => (
                                                    <button
                                                        key={material.mat_ID}
                                                        className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                        type="button"
                                                        onClick={() => {
                                                            handleMaterialSelect(material);
                                                            setSelectedMaterialColor(material.color);
                                                            setCurrentDencity(material.density);
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <ColorBox color={material.color} />
                                                            <span className="ms-2">{material.name}</span>
                                                        </div>
                                                    </button>
                                                ))
                                            ) : (
                                                <button className="dropdown-item" type="button" disabled>
                                                    No materials found
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold text-muted">Qty</label>
                                        <div className="input-step d-flex align-items-center w-100">
                                            <button type="button" className="minus" onClick={() => handleDecreaseQuantity()}>–</button>
                                            <input
                                                type="number"
                                                className="text-center mx-2 product-quantity w-100"
                                                value={formData.qty ? formData.qty : 1}
                                                min="0"
                                                max="100"
                                                readOnly
                                            />
                                            <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseQuantity()}>+</button>
                                        </div>
                                    </div>

                                    <div className="col-12 mb-3">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="me-3">
                                                    <div style={{ height: "25vh", width: "40vh" }}>
                                                        {getFileExtension(fileURL) === "stl" ? (
                                                            <SimpleSTLViewer url={fileURL} />
                                                        ) : (
                                                            fileURL && (
                                                                <img src={fileURL} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div style={{
                                                    height: "25vh", width: "40vh", maxWidth: "100%",
                                                    maxHeight: "100%",
                                                    border: "1px solid #dcdcdc",
                                                    padding: "2px"
                                                }}>
                                                    <center><h6 className="text-muted">Description</h6></center>
                                                    <p className="mb-0 text-muted fs-100 m-2 mt-3">
                                                        Mould type: Vulcanised<br />
                                                        Mould created: 01/01/2020<br />
                                                        4 Claw solitaire<br />
                                                        Material: Steel<br />
                                                        Size: L
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 text-end">
                                        <button className="btn btn-info text-white" onClick={() => {
                                            UpdateMouldModal()
                                        }}
                                        >{isUpdateJob === 0 ? "Add Mould" : "Update Mould"}</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default UpdateQuotation;
